export const openEditOrder = (params?: object) => Tools.$upModal.open('editOrder', params);
